import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faAngleDoubleLeft, faAngleDoubleRight,
    faCalendarAlt,
    faDownload, faInfoCircle, faMapMarkerAlt,
    faSlidersH,
    faTimes,
    faTruck
} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";


import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import Loading from "../Common/Loading";
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"


let pages = [];
for(let p = 1 ; p < 50 ; p++){
    pages[p] = p;
}

const currencyFormat = Intl.NumberFormat('en-US');

class Home extends Component {
    state = {
        requests : [],
        trackingCode : '',
        statuses : [],
        drivers : [],
        status: window.localStorage.getItem("status_id"),
        date_from:window.localStorage.getItem("date_from"),
        date_to: window.localStorage.getItem("date_to"),
        isLoaded:false,
        companyName : window.localStorage.getItem("company_name") ? window.localStorage.getItem("company_name") : '',
        showModal : false,
        count : 0,
        searchButtonLabel : 'فیلتر'

    }
    onSearchTrackingCode = (event) => {
        this.setState({
            trackingCode:event.target.value
        })
        if(event.target.value.length > 2) {
            const request = {
                proccess_for : 'Expert',
                tracking_code : event.target.value,
                small_cargo : 0
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests,count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                proccess_for : 'Expert',
                small_cargo : 0

            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    advancedSearch = (event) => {

        this.setState({searchButtonLabel : 'در حال جستجو'})
        const toMonth = this.state.date_to?.toDate?.().getMonth() -(-1);
        const fromMonth = this.state.date_from?.toDate?.().getMonth() -(-1);

            const request = {
                proccess_for : 'Expert',
                company_name : this.state.companyName,
                status_id: this.state.status? this.state.status : '',
                date_from: typeof this.state.date_from?.toDate?.().getFullYear() !== "undefined" ? this.state.date_from?.toDate?.().getFullYear() + '-' + fromMonth + '-' +this.state.date_from?.toDate?.().getDate() + ' 00:00' : '',
                date_to: typeof this.state.date_to?.toDate?.().getFullYear() !== "undefined" ? this.state.date_to?.toDate?.().getFullYear() + '-' + toMonth + '-' + this.state.date_to?.toDate?.().getDate() + ' 23:59': '',
                small_cargo : 0
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count,showModal : false , searchButtonLabel : 'فیلتر  '})

                    window.localStorage.setItem("company_name",request.company_name);
                    window.localStorage.setItem("status_id",request.status_id);
                    window.localStorage.setItem("date_to", request.date_to);
                    window.localStorage.setItem("date_from",request.date_from);



                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });

    }
    onStateChange = (event) => {

        this.setState({status : event.target.value});
        const request = {
            proccess_for : 'Expert',
            status_id: event.target.value,
            company_name :  this.state.companyName,
            small_cargo : 0

        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                const count = response.results.count;
                this.setState({requests , count})

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast  />
                <Actionbar noBack={1} title=' لیست درخواست ها'/>
                {
                    this.state.showModal &&
                    <section className="container-fluid modal-bg max-w-lg">
                        <div className="row rtl">
                            <div className="col-12 ">
                                <div className="row modal-card "

                                >
                                    <div className="col-12 border-bottom text-center my-2 text-primary small">
                                        جستجوی پیشرفته درخواست ها
                                    </div>
                                    <div className="col-12 super-small-2 text-secondary mt-2">
                                        <FontAwesomeIcon icon={faCalendarAlt}  className='px-2'/>
                                        تاریخ ثبت درخواست:
                                    </div>
                                    <div className="col-6 super-small">
                                        <span className='float-right'>
                                            از:
                                        </span>
                                        <DatePicker

                                            onChange={ (val) => this.setState({date_from: val}) }
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition= "bottom-right"
                                            className="rmdp-mobile"
                                            //value={this.state.date_from}

                                        />

                                    </div>
                                    <div className="col-6 super-small">
                                        <span className='float-right'>
                                            تا:
                                        </span>
                                        <DatePicker
                                            //value={this.state.date_to}
                                            onChange={ (val) => this.setState({date_to: val}) }
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition= "bottom-right"
                                            className="rmdp-mobile"

                                        />
                                  {/*      <DatePicker
                                            calendarStyles={styles}
                                            inputFormat="jYYYY/jM/jD"
                                            className="form-control persian-date super-small w-75 float-left"
                                            value={this.state.date_to}
                                            onChange={(value)=>this.setState({'date_to' : value})}
                                        />*/}
                                    </div>

                                    <div className="col-12 mt-2">
                                        <div className="form-floating super-small-2">
                                            <input type="text" className="form-control height-40" id="floatingInput"
                                                   placeholder="جستجو  شرکت"
                                                   onChange={
                                                       (val) => {
                                                           this.setState({
                                                               companyName : val.target.value
                                                           })
                                                       }
                                                   }
                                                   value={this.state.companyName}
                                            />
                                            <label htmlFor="floatingInput"> نام شرکت</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group ">
                                            <select className="form-select w-100 super-small py-2 bg-light" id="statuses" name="statuses"
                                                    aria-label=" label select example"
                                                    value={this.state.status}
                                                    onChange={(val) =>  {
                                                        this.setState({status : val.target.value});
                                                    }} >
                                                <option value={0}>
                                                     وضعیت
                                                </option>
                                                {this.state.statuses.map(st => {
                                                    return (
                                                        <option value={st.id} key={st.id} style={{color:st.color}}>
                                                            {st.title}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                        </div>

                                    </div>
                 {/*                   <div className="col-12">
                                        <div className="form-group ">
                                            <select className="form-select w-100 super-small py-2 bg-light" id="statuses" name="statuses"
                                                    aria-label=" label select example"
                                                    value={this.state.status}
                                                    onChange={this.onStateChange} >
                                                <option value={0}>
                                                     راننده
                                                </option>
                                                {this.state.drivers.map(driver => {
                                                    return (
                                                        <option value={driver.id} key={driver.id} >
                                                            {driver.full_name}
                                                        </option>
                                                    )
                                                })}
                                            </select>
                                        </div>

                                    </div>
                                */}
                                    <div className="col-6 my-2 ">
                                        <button className='btn bg-primary text-white
                                        super-small-2 w-100 p-2'
                                                onClick={this.advancedSearch}
                                        >
                                            <FontAwesomeIcon icon={faSlidersH} className='ms-2'/>
                                            {this.state.searchButtonLabel}
                                        </button>
                                    </div>
                                    <div className="col-6 my-2">
                                        <button className='btn bg-danger text-white super-small-2 w-100 p-2 '
                                                onClick={() => {
                                                    this.setState({
                                                        showModal: false,
                                                        status: '',
                                                        companyName: '',
                                                        date_to: '',
                                                        date_from: '',
                                                    })
                                                    window.localStorage.removeItem("company_name");
                                                    window.localStorage.removeItem("status_id");
                                                    window.localStorage.removeItem("date_to");
                                                    window.localStorage.removeItem("date_from");
                                                    setTimeout (() => {
                                                        this.advancedSearch()
                                                    },600)

                                                }}
                                        >
                                            <FontAwesomeIcon icon={faTimes} className='ms-2'/>
                                            پاک کردن فیلتر
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
                <section className="container my-5 py-4 ">



                    <div className="row alert alert-secondary rtl super-small-2 p-0 py-2">
                        <div className="col-4 text-center px-1 "
                        onClick={() => {
                            this.setState({
                                showModal : true
                            });

                        }}
                        >
                            <span className='btn btn-outline-dark super-small-2 w-100'>
                                <FontAwesomeIcon icon={faSlidersH} className='ps-1' />
                                فیلتر پیشرفته
                            </span>

                        </div>
                        <div className="col-8 text-left">
                            <span className='mx-3'>برو به:</span>
                            <select onChange={(val) => {window.location.assign("/home/" + val.target.value)}} className='w-50 text-center bg-white text-dark small rounded'
                            value={parseInt(this.props.match.params.page)}
                            >
                                {
                                    pages.map (p => {
                                        return (
                                            <option value={p}
                                                    key={p}
                                            >
                                                صفحه
                                                &nbsp;
                                                {p}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row mb-2 rtl">
                        <div className="col-6 text-center super-small text-secondary pt-2">
                            تعداد کل :
                            &nbsp;
                            {this.state.count}
                            &nbsp;
                            درخواست
                        </div>
                        <div className="col-6">
                            <div className="form-floating super-small-2">
                                <input type="number" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو کد رهگیری"
                                       onChange={this.onSearchTrackingCode}
                                       value={this.state.trackingCode}
                                />
                                <label htmlFor="floatingInput">جستجو کد رهگیری</label>
                            </div>
                        </div>
                    </div>
                    <div className="row px-2">
                        {
                            this.state.requests.map (request => {
                                return (
                                    <div className="col-12 rtl mb-2 request-row pb-2 bg-light "
                                         onClick={() => this.props.history.push(`/request/${request.id}`)}
                                         key={request.id}
                                    >
                                        <div className="row  mx-2 py-2">
                                            <div className="col-6 badge badge-info badge-pill text-dark  float-right border py-2 mb-3 bg-white">{request.company.title}

                                                <span className='small pe-2'>{request.loading_date}
                                                    &nbsp;
                                                    <FontAwesomeIcon icon={faCalendarAlt}/></span>
                                               </div>
                                            <div className="col-6 text-left super-small-2" style={{color:request.status.color}}>{request.status.title}</div>
                                           {/* <div className="col-12 mt-2 super-small">
                                                از:
                                                &nbsp;
                                                {request.loading_addresses[0].title}
                                                &nbsp;
                                                {request.loading_addresses[0].address.substring(0, 25)} ...
                                            </div>*/}

                                            <div className="col-12 mt-2 super-small">
                                                <FontAwesomeIcon icon={faDownload} />
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].title}
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].address.substring(0, 40)} ...

                                                &nbsp;

                                               <div className="float-start">
                                                   {
                                                       request.driverOnline === 1 &&
                                                       <FontAwesomeIcon icon={faMapMarkerAlt} className='text-success text-big'  />
                                                   }
                                                   {
                                                       request.driverOnline === 0 &&
                                                       <FontAwesomeIcon icon={faMapMarkerAlt} className='text-danger text-big'  />
                                                   }
                                               </div>
                                            </div>
                                            <div className="col-12 mt-3 ">
                                                <div className='float-left text-dark'>

                                              <span className=' badge bg-dark bg-opacity-75 small'>
                                                    {request.tracking_code}
                                                </span>

                                                </div>
                                                <div className='super-small-2'>
                                                    <FontAwesomeIcon icon={faTruck} className='text-secondary' />
                                                    &nbsp;
                                                    {request.car_type.parent}
                                                    &nbsp;
                                                    -
                                                    &nbsp;
                                                    {request.car_type.title}
                                                    &nbsp;&nbsp;
                                                    {request.driver.last_name ?

                                                        <strong>
                                                            (
                                                            {request.driver.last_name}
                                                            -
                                                            &nbsp;
                                                            {currencyFormat.format(request.driver_share)}
                                                            &nbsp;
                                                            ریال
                                                            )
                                                        </strong>
                                                        : ''
                                                    }




                                                </div>
                                                {
                                                    request.description?.length > 2 ?
                                                        <div className='text-danger super-small mt-3'>
                                                            <FontAwesomeIcon icon={faInfoCircle} className='ms-1' />
                                                            {request.description}
                                                        </div>
                                                        : ''
                                                }

                                            </div>
                                        </div>
                                    </div>
                                )} )
                        }
                    </div>
                    <div className="row">
                        <div className="col-6">
                           <button className='btn btn-primary super-small-2'
                                   onClick={
                               () => {
                                   const page = this.props.match.params.page ? parseInt(this.props.match.params.page) + 1 : 2
                                   window.location.assign("/home/" + page)
                               }
                           }
                           >
                               <FontAwesomeIcon icon={faAngleDoubleLeft} className='mx-2' />
                               صفحه بعد

                           </button>
                        </div>
                        <div className="col-6 text-right">
                            { parseInt(this.props.match.params.page) > 1 &&

                                <button className='btn btn-warning super-small-2 '
                                        onClick={
                                            () => {
                                                const page = this.props.match.params.page ? parseInt(this.props.match.params.page) - 1 : 2
                                                window.location.assign("/home/" + page)
                                            }
                                        }
                                >

                                    صفحه قبل
                                    <FontAwesomeIcon icon={faAngleDoubleRight} className='mx-2' />
                                </button>
                            }

                        </div>
                    </div>
                </section>

                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {

        const request = {
            page: this.props.match.params.page ? this.props.match.params.page : 1,
            proccess_for : 'Expert',
            company_name : this.state.companyName,
            status_id: this.state.status,
            date_from: this.state.date_from,
            date_to:  this.state.date_to,
            small_cargo : 0
        }

        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                const count = response.results.count;
                this.setState({requests , count})
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

        API.getStatuses()
            .then((response) => {
                const statuses = response.results.statuses;
                this.setState({statuses})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });


        const requestDriver = {
            expert_drivers : true,

        }
        API.getDrivers(requestDriver)
            .then((response) => {
                this.setState({drivers : response.results.drivers , request : response.results.request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

    }
}

export default Home;